<template>
  <Breadcrumbs
      title="Dealer Groups"
      :breadcrumbs="[
      { label: 'Master Data', path: '' },
      { label: 'Dealer Groups', path: '/dealer-groups' },
      { label: 'Create Dealer Group', path: '/create-dealer-group' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <createDealerGroupForm/>
    </div>
  </div>
</template>

<script>

import createDealerGroupForm from "@/pages/master_data/dealer_groups/createDealerGroupForm.vue";

export default {
  components: {
    createDealerGroupForm
  }
}
</script>